import { render, staticRenderFns } from "./permissionAssign.vue?vue&type=template&id=8c5526fe&scoped=true&"
import script from "./permissionAssign.vue?vue&type=script&lang=js&"
export * from "./permissionAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5526fe",
  null
  
)

export default component.exports